module.exports = __webpack_public_path__ + "img/pellets-banner.d40ea5e.webp";